import { useEffect } from "react";
import { AlmeConfig } from "../models/AlmeConfig";

export function UseLiveChatConnected(isLiveChatConnected: boolean, almeConfig: AlmeConfig, setAlmeConfig: (almeConfig: AlmeConfig) => void): void {
    useEffect(() => {
        if (isLiveChatConnected && !almeConfig.notificationApi.pollForLiveChat) {
            setAlmeConfig({
                ...almeConfig,
                notificationApi: {
                    ...almeConfig.notificationApi,
                    pollForLiveChat: true,
                },
            });
        } else if (!isLiveChatConnected && almeConfig.notificationApi.pollForLiveChat) {
            setAlmeConfig({
                ...almeConfig,
                notificationApi: {
                    ...almeConfig.notificationApi,
                    pollForLiveChat: false,
                },
            });
        }

    }, [almeConfig, isLiveChatConnected, setAlmeConfig]);
}